"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryCodeToNameMap = exports.COUNTRY_CODES = void 0;
// Copied from https://livegrep.sc-corp.net/view/Snapchat/web-self-serve-ads/shared/client-shared/scripts/l10n/constants/countryCodes.ts
exports.COUNTRY_CODES = [
    "BD",
    "BE",
    "BF",
    "BG",
    "BA",
    "BB",
    "WF",
    "BL",
    "BM",
    "BN",
    "BO",
    "BH",
    "BI",
    "BJ",
    "BT",
    "JM",
    "BV",
    "BW",
    "WS",
    "BQ",
    "BR",
    "BS",
    "JE",
    "BY",
    "BZ",
    "RU",
    "RW",
    "RS",
    "TL",
    "RE",
    "TM",
    "TJ",
    "RO",
    "TK",
    "GW",
    "GU",
    "GT",
    "GS",
    "GR",
    "GQ",
    "GP",
    "JP",
    "GY",
    "GG",
    "GF",
    "GE",
    "GD",
    "GB",
    "UK",
    "GA",
    "SV",
    "GN",
    "GM",
    "GL",
    "GI",
    "GH",
    "OM",
    "TN",
    "JO",
    "HR",
    "HT",
    "HU",
    "HK",
    "HN",
    "HM",
    "VE",
    "PR",
    "PS",
    "PW",
    "PT",
    "SJ",
    "PY",
    "IQ",
    "PA",
    "PF",
    "PG",
    "PE",
    "PK",
    "PH",
    "PN",
    "PL",
    "PM",
    "ZM",
    "EH",
    "EE",
    "EG",
    "ZA",
    "EC",
    "IT",
    "VN",
    "SB",
    "ET",
    "SO",
    "ZW",
    "SA",
    "ES",
    "ER",
    "ME",
    "MD",
    "MG",
    "MF",
    "MA",
    "MC",
    "UZ",
    "MM",
    "ML",
    "MO",
    "MN",
    "MH",
    "MK",
    "MU",
    "MT",
    "MW",
    "MV",
    "MQ",
    "MP",
    "MS",
    "MR",
    "IM",
    "UG",
    "TZ",
    "MY",
    "MX",
    "IL",
    "FR",
    "IO",
    "SH",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "NI",
    "NL",
    "NO",
    "NA",
    "VU",
    "NC",
    "NE",
    "NF",
    "NG",
    "NZ",
    "NP",
    "NR",
    "NU",
    "CK",
    "XK",
    "CI",
    "CH",
    "CO",
    "CN",
    "CM",
    "CL",
    "CC",
    "CA",
    "CG",
    "CF",
    "CD",
    "CZ",
    "CY",
    "CX",
    "CR",
    "CW",
    "CV",
    "CU",
    "SZ",
    "SY",
    "SX",
    "KG",
    "KE",
    "SS",
    "SR",
    "KI",
    "KH",
    "KN",
    "KM",
    "ST",
    "SK",
    "KR",
    "SI",
    "KP",
    "KW",
    "SN",
    "SM",
    "SL",
    "SC",
    "KZ",
    "KY",
    "SG",
    "SE",
    "SD",
    "DO",
    "DM",
    "DJ",
    "DK",
    "VG",
    "DE",
    "YE",
    "DZ",
    "US",
    "UY",
    "YT",
    "UM",
    "LB",
    "LC",
    "LA",
    "TV",
    "TW",
    "TT",
    "TR",
    "LK",
    "LI",
    "LV",
    "TO",
    "LT",
    "LU",
    "LR",
    "LS",
    "TH",
    "TF",
    "TG",
    "TD",
    "TC",
    "LY",
    "VA",
    "VC",
    "AE",
    "AD",
    "AG",
    "AF",
    "AI",
    "VI",
    "IS",
    "IR",
    "AM",
    "AL",
    "AO",
    "AQ",
    "AS",
    "AR",
    "AU",
    "AT",
    "AW",
    "IN",
    "AX",
    "AZ",
    "IE",
    "ID",
    "UA",
    "QA",
    "MZ",
];
const getCountryCodeToNameMap = (intl) => new Map([
    ["BD", intl.formatMessage({ id: "gEWjsM", defaultMessage: "Bangladesh" })],
    ["BE", intl.formatMessage({ id: "o5InVy", defaultMessage: "Belgium" })],
    ["BF", intl.formatMessage({ id: "1ROxNo", defaultMessage: "Burkina Faso" })],
    ["BG", intl.formatMessage({ id: "uLjfHx", defaultMessage: "Bulgaria" })],
    ["BA", intl.formatMessage({ id: "IxV+TQ", defaultMessage: "Bosnia and Herzegovina" })],
    ["BB", intl.formatMessage({ id: "IC39KF", defaultMessage: "Barbados" })],
    ["WF", intl.formatMessage({ id: "HqSThL", defaultMessage: "Wallis and Futuna" })],
    ["BL", intl.formatMessage({ id: "OthFOe", defaultMessage: "Saint Barthelemy" })],
    ["BM", intl.formatMessage({ id: "lNpHJU", defaultMessage: "Bermuda" })],
    ["BN", intl.formatMessage({ id: "NYfs4P", defaultMessage: "Brunei" })],
    ["BO", intl.formatMessage({ id: "6ZgBbw", defaultMessage: "Bolivia" })],
    ["BH", intl.formatMessage({ id: "/5cdjt", defaultMessage: "Bahrain" })],
    ["BI", intl.formatMessage({ id: "o+2sFT", defaultMessage: "Burundi" })],
    ["BJ", intl.formatMessage({ id: "inFU+b", defaultMessage: "Benin" })],
    ["BT", intl.formatMessage({ id: "MK2kPw", defaultMessage: "Bhutan" })],
    ["JM", intl.formatMessage({ id: "QQFsPa", defaultMessage: "Jamaica" })],
    ["BV", intl.formatMessage({ id: "XBrZ16", defaultMessage: "Bouvet Island" })],
    ["BW", intl.formatMessage({ id: "+hgjwh", defaultMessage: "Botswana" })],
    ["WS", intl.formatMessage({ id: "tvE5JV", defaultMessage: "Samoa" })],
    [
        "BQ",
        intl.formatMessage({ id: "aoCYHZ", defaultMessage: "Bonaire, Saint Eustatius and Saba" }),
    ],
    ["BR", intl.formatMessage({ id: "zJ+Qdi", defaultMessage: "Brazil" })],
    ["BS", intl.formatMessage({ id: "Vur4Pc", defaultMessage: "Bahamas" })],
    ["JE", intl.formatMessage({ id: "QEpb4w", defaultMessage: "Jersey" })],
    ["BY", intl.formatMessage({ id: "ZwfOoA", defaultMessage: "Belarus" })],
    ["BZ", intl.formatMessage({ id: "dtDgwz", defaultMessage: "Belize" })],
    ["RU", intl.formatMessage({ id: "OhkbDU", defaultMessage: "Russia" })],
    ["RW", intl.formatMessage({ id: "Co/5iq", defaultMessage: "Rwanda" })],
    ["RS", intl.formatMessage({ id: "fV65BM", defaultMessage: "Serbia" })],
    ["TL", intl.formatMessage({ id: "/uf3l4", defaultMessage: "East Timor" })],
    ["RE", intl.formatMessage({ id: "30Mg5/", defaultMessage: "Reunion" })],
    ["TM", intl.formatMessage({ id: "884qo6", defaultMessage: "Turkmenistan" })],
    ["TJ", intl.formatMessage({ id: "2DrFi/", defaultMessage: "Tajikistan" })],
    ["RO", intl.formatMessage({ id: "Jnm5JX", defaultMessage: "Romania" })],
    ["TK", intl.formatMessage({ id: "WELugi", defaultMessage: "Tokelau" })],
    ["GW", intl.formatMessage({ id: "hz2KSv", defaultMessage: "Guinea-Bissau" })],
    ["GU", intl.formatMessage({ id: "ec+8jt", defaultMessage: "Guam" })],
    ["GT", intl.formatMessage({ id: "fApUje", defaultMessage: "Guatemala" })],
    [
        "GS",
        intl.formatMessage({
            id: "cCiGhf",
            defaultMessage: "South Georgia and the South Sandwich Islands",
        }),
    ],
    ["GR", intl.formatMessage({ id: "yil/vB", defaultMessage: "Greece" })],
    ["GQ", intl.formatMessage({ id: "A0QuW0", defaultMessage: "Equatorial Guinea" })],
    ["GP", intl.formatMessage({ id: "g12swr", defaultMessage: "Guadeloupe" })],
    ["JP", intl.formatMessage({ id: "3Rh+pv", defaultMessage: "Japan" })],
    ["GY", intl.formatMessage({ id: "y19xMJ", defaultMessage: "Guyana" })],
    ["GG", intl.formatMessage({ id: "Fohnyv", defaultMessage: "Guernsey" })],
    ["GF", intl.formatMessage({ id: "5FAe7C", defaultMessage: "French Guiana" })],
    ["GE", intl.formatMessage({ id: "C/46Vz", defaultMessage: "Georgia" })],
    ["GD", intl.formatMessage({ id: "Wyr8z1", defaultMessage: "Grenada" })],
    ["GB", intl.formatMessage({ id: "SKtwiU", defaultMessage: "United Kingdom" })],
    ["UK", intl.formatMessage({ id: "SKtwiU", defaultMessage: "United Kingdom" })],
    ["GA", intl.formatMessage({ id: "elJBhI", defaultMessage: "Gabon" })],
    ["SV", intl.formatMessage({ id: "lAqxac", defaultMessage: "El Salvador" })],
    ["GN", intl.formatMessage({ id: "rbZX5h", defaultMessage: "Guinea" })],
    ["GM", intl.formatMessage({ id: "58SIKu", defaultMessage: "Gambia" })],
    ["GL", intl.formatMessage({ id: "sroDBL", defaultMessage: "Greenland" })],
    ["GI", intl.formatMessage({ id: "Yn6mMH", defaultMessage: "Gibraltar" })],
    ["GH", intl.formatMessage({ id: "PJLOZK", defaultMessage: "Ghana" })],
    ["OM", intl.formatMessage({ id: "uWzT/K", defaultMessage: "Oman" })],
    ["TN", intl.formatMessage({ id: "d8Z26u", defaultMessage: "Tunisia" })],
    ["JO", intl.formatMessage({ id: "BoKhrr", defaultMessage: "Jordan" })],
    ["HR", intl.formatMessage({ id: "Evxi/h", defaultMessage: "Croatia" })],
    ["HT", intl.formatMessage({ id: "TTeL00", defaultMessage: "Haiti" })],
    ["HU", intl.formatMessage({ id: "T6CwRX", defaultMessage: "Hungary" })],
    ["HK", intl.formatMessage({ id: "JFYhZv", defaultMessage: "Hong Kong" })],
    ["HN", intl.formatMessage({ id: "gI1AIL", defaultMessage: "Honduras" })],
    [
        "HM",
        intl.formatMessage({ id: "NMHpYu", defaultMessage: "Heard Island and McDonald Islands" }),
    ],
    ["VE", intl.formatMessage({ id: "ZkjVLX", defaultMessage: "Venezuela" })],
    ["PR", intl.formatMessage({ id: "52kdGd", defaultMessage: "Puerto Rico" })],
    ["PS", intl.formatMessage({ id: "LSP7zt", defaultMessage: "Palestinian Territory" })],
    ["PW", intl.formatMessage({ id: "7Yy0+b", defaultMessage: "Palau" })],
    ["PT", intl.formatMessage({ id: "67jBS8", defaultMessage: "Portugal" })],
    ["SJ", intl.formatMessage({ id: "ke3zkV", defaultMessage: "Svalbard and Jan Mayen" })],
    ["PY", intl.formatMessage({ id: "mNZnPy", defaultMessage: "Paraguay" })],
    ["IQ", intl.formatMessage({ id: "qAiQn0", defaultMessage: "Iraq" })],
    ["PA", intl.formatMessage({ id: "+c9FIk", defaultMessage: "Panama" })],
    ["PF", intl.formatMessage({ id: "vzHYL7", defaultMessage: "French Polynesia" })],
    ["PG", intl.formatMessage({ id: "/0qKds", defaultMessage: "Papua New Guinea" })],
    ["PE", intl.formatMessage({ id: "5+dpGU", defaultMessage: "Peru" })],
    ["PK", intl.formatMessage({ id: "u5SBAU", defaultMessage: "Pakistan" })],
    ["PH", intl.formatMessage({ id: "RRQ7fk", defaultMessage: "Philippines" })],
    ["PN", intl.formatMessage({ id: "eAWOo4", defaultMessage: "Pitcairn" })],
    ["PL", intl.formatMessage({ id: "SZjU9E", defaultMessage: "Poland" })],
    ["PM", intl.formatMessage({ id: "vg7g/j", defaultMessage: "Saint Pierre and Miquelon" })],
    ["ZM", intl.formatMessage({ id: "t50FYQ", defaultMessage: "Zambia" })],
    ["EH", intl.formatMessage({ id: "XEAUVf", defaultMessage: "Western Sahara" })],
    ["EE", intl.formatMessage({ id: "oM/Jlx", defaultMessage: "Estonia" })],
    ["EG", intl.formatMessage({ id: "BIR9MS", defaultMessage: "Egypt" })],
    ["ZA", intl.formatMessage({ id: "XR8z3v", defaultMessage: "South Africa" })],
    ["EC", intl.formatMessage({ id: "TkvM0N", defaultMessage: "Ecuador" })],
    ["IT", intl.formatMessage({ id: "VzQxqn", defaultMessage: "Italy" })],
    ["VN", intl.formatMessage({ id: "+ieU8R", defaultMessage: "Vietnam" })],
    ["SB", intl.formatMessage({ id: "EfncpL", defaultMessage: "Solomon Islands" })],
    ["ET", intl.formatMessage({ id: "HkNqjk", defaultMessage: "Ethiopia" })],
    ["SO", intl.formatMessage({ id: "NqFp7f", defaultMessage: "Somalia" })],
    ["ZW", intl.formatMessage({ id: "gaBIUj", defaultMessage: "Zimbabwe" })],
    ["SA", intl.formatMessage({ id: "cbMqh0", defaultMessage: "Saudi Arabia" })],
    ["ES", intl.formatMessage({ id: "GL9Msi", defaultMessage: "Spain" })],
    ["ER", intl.formatMessage({ id: "4+tITf", defaultMessage: "Eritrea" })],
    ["ME", intl.formatMessage({ id: "nxY39E", defaultMessage: "Montenegro" })],
    ["MD", intl.formatMessage({ id: "8EnWa6", defaultMessage: "Moldova" })],
    ["MG", intl.formatMessage({ id: "aNjcfm", defaultMessage: "Madagascar" })],
    ["MF", intl.formatMessage({ id: "fg3e0r", defaultMessage: "Saint Martin" })],
    ["MA", intl.formatMessage({ id: "s8wxd4", defaultMessage: "Morocco" })],
    ["MC", intl.formatMessage({ id: "qXzX3N", defaultMessage: "Monaco" })],
    ["UZ", intl.formatMessage({ id: "IOia3K", defaultMessage: "Uzbekistan" })],
    ["MM", intl.formatMessage({ id: "lSPuI7", defaultMessage: "Myanmar" })],
    ["ML", intl.formatMessage({ id: "I73NDr", defaultMessage: "Mali" })],
    ["MO", intl.formatMessage({ id: "h3dgEP", defaultMessage: "Macao" })],
    ["MN", intl.formatMessage({ id: "sxNj0/", defaultMessage: "Mongolia" })],
    ["MH", intl.formatMessage({ id: "iVENNr", defaultMessage: "Marshall Islands" })],
    ["MK", intl.formatMessage({ id: "ByhIs0", defaultMessage: "Macedonia" })],
    ["MU", intl.formatMessage({ id: "XBetJ4", defaultMessage: "Mauritius" })],
    ["MT", intl.formatMessage({ id: "k8wgb4", defaultMessage: "Malta" })],
    ["MW", intl.formatMessage({ id: "/hi87u", defaultMessage: "Malawi" })],
    ["MV", intl.formatMessage({ id: "Q11y5F", defaultMessage: "Maldives" })],
    ["MQ", intl.formatMessage({ id: "Bq2nwA", defaultMessage: "Martinique" })],
    ["MP", intl.formatMessage({ id: "krCZKf", defaultMessage: "Northern Mariana Islands" })],
    ["MS", intl.formatMessage({ id: "MKz1Tv", defaultMessage: "Montserrat" })],
    ["MR", intl.formatMessage({ id: "sXmy5o", defaultMessage: "Mauritania" })],
    ["IM", intl.formatMessage({ id: "ub/Qvb", defaultMessage: "Isle of Man" })],
    ["UG", intl.formatMessage({ id: "6TiqPJ", defaultMessage: "Uganda" })],
    ["TZ", intl.formatMessage({ id: "Q23n/U", defaultMessage: "Tanzania" })],
    ["MY", intl.formatMessage({ id: "b7zond", defaultMessage: "Malaysia" })],
    ["MX", intl.formatMessage({ id: "QXG+La", defaultMessage: "Mexico" })],
    ["IL", intl.formatMessage({ id: "vwXIZQ", defaultMessage: "Israel" })],
    ["FR", intl.formatMessage({ id: "9KADbj", defaultMessage: "France" })],
    ["IO", intl.formatMessage({ id: "Jo8O9K", defaultMessage: "British Indian Ocean Territory" })],
    ["SH", intl.formatMessage({ id: "rzohCf", defaultMessage: "Saint Helena" })],
    ["FI", intl.formatMessage({ id: "OIc/xw", defaultMessage: "Finland" })],
    ["FJ", intl.formatMessage({ id: "zSzTfC", defaultMessage: "Fiji" })],
    ["FK", intl.formatMessage({ id: "Jm15g7", defaultMessage: "Falkland Islands" })],
    ["FM", intl.formatMessage({ id: "P5VGig", defaultMessage: "Micronesia" })],
    ["FO", intl.formatMessage({ id: "aZxVvE", defaultMessage: "Faroe Islands" })],
    ["NI", intl.formatMessage({ id: "IeYjFw", defaultMessage: "Nicaragua" })],
    ["NL", intl.formatMessage({ id: "hT/s2i", defaultMessage: "Netherlands" })],
    ["NO", intl.formatMessage({ id: "mdq/wu", defaultMessage: "Norway" })],
    ["NA", intl.formatMessage({ id: "DYK0ve", defaultMessage: "Namibia" })],
    ["VU", intl.formatMessage({ id: "/9BpZC", defaultMessage: "Vanuatu" })],
    ["NC", intl.formatMessage({ id: "HNQOND", defaultMessage: "New Caledonia" })],
    ["NE", intl.formatMessage({ id: "uXZM4v", defaultMessage: "Niger" })],
    ["NF", intl.formatMessage({ id: "81kGin", defaultMessage: "Norfolk Island" })],
    ["NG", intl.formatMessage({ id: "uKVTE3", defaultMessage: "Nigeria" })],
    ["NZ", intl.formatMessage({ id: "tcWR8m", defaultMessage: "New Zealand" })],
    ["NP", intl.formatMessage({ id: "tGuLQJ", defaultMessage: "Nepal" })],
    ["NR", intl.formatMessage({ id: "4tH4ib", defaultMessage: "Nauru" })],
    ["NU", intl.formatMessage({ id: "cPyO3E", defaultMessage: "Niue" })],
    ["CK", intl.formatMessage({ id: "MQbqy9", defaultMessage: "Cook Islands" })],
    ["XK", intl.formatMessage({ id: "tHXDZ5", defaultMessage: "Kosovo" })],
    ["CI", intl.formatMessage({ id: "UueyB1", defaultMessage: "Ivory Coast" })],
    ["CH", intl.formatMessage({ id: "ERkh0f", defaultMessage: "Switzerland" })],
    ["CO", intl.formatMessage({ id: "PZh7w+", defaultMessage: "Colombia" })],
    ["CN", intl.formatMessage({ id: "1q/ois", defaultMessage: "China" })],
    ["CM", intl.formatMessage({ id: "ECeXar", defaultMessage: "Cameroon" })],
    ["CL", intl.formatMessage({ id: "QtvgOo", defaultMessage: "Chile" })],
    ["CC", intl.formatMessage({ id: "57yuyz", defaultMessage: "Cocos Islands" })],
    ["CA", intl.formatMessage({ id: "2abiy0", defaultMessage: "Canada" })],
    ["CG", intl.formatMessage({ id: "iYEhZN", defaultMessage: "Republic of the Congo" })],
    ["CF", intl.formatMessage({ id: "MjNTEu", defaultMessage: "Central African Republic" })],
    [
        "CD",
        intl.formatMessage({ id: "0hPPc+", defaultMessage: "Democratic Republic of the Congo" }),
    ],
    ["CZ", intl.formatMessage({ id: "+d/tNA", defaultMessage: "Czech Republic" })],
    ["CY", intl.formatMessage({ id: "f51mrK", defaultMessage: "Cyprus" })],
    ["CX", intl.formatMessage({ id: "4mW6ME", defaultMessage: "Christmas Island" })],
    ["CR", intl.formatMessage({ id: "HmnV8f", defaultMessage: "Costa Rica" })],
    ["CW", intl.formatMessage({ id: "WLYW6/", defaultMessage: "Curacao" })],
    ["CV", intl.formatMessage({ id: "UQHsPm", defaultMessage: "Cape Verde" })],
    ["CU", intl.formatMessage({ id: "6qOZYA", defaultMessage: "Cuba" })],
    ["SZ", intl.formatMessage({ id: "VGYe8e", defaultMessage: "Swaziland" })],
    ["SY", intl.formatMessage({ id: "G5CvJf", defaultMessage: "Syria" })],
    ["SX", intl.formatMessage({ id: "eZzIn6", defaultMessage: "Sint Maarten" })],
    ["KG", intl.formatMessage({ id: "+Im81x", defaultMessage: "Kyrgyzstan" })],
    ["KE", intl.formatMessage({ id: "6307RX", defaultMessage: "Kenya" })],
    ["SS", intl.formatMessage({ id: "ZOWwOS", defaultMessage: "South Sudan" })],
    ["SR", intl.formatMessage({ id: "PHVDJ8", defaultMessage: "Suriname" })],
    ["KI", intl.formatMessage({ id: "rkGcmk", defaultMessage: "Kiribati" })],
    ["KH", intl.formatMessage({ id: "cB8Agh", defaultMessage: "Cambodia" })],
    ["KN", intl.formatMessage({ id: "4O4dPg", defaultMessage: "Saint Kitts and Nevis" })],
    ["KM", intl.formatMessage({ id: "zB+1uJ", defaultMessage: "Comoros" })],
    ["ST", intl.formatMessage({ id: "A//js0", defaultMessage: "Sao Tome and Principe" })],
    ["SK", intl.formatMessage({ id: "kkyKXY", defaultMessage: "Slovakia" })],
    ["KR", intl.formatMessage({ id: "tnrxhT", defaultMessage: "South Korea" })],
    ["SI", intl.formatMessage({ id: "LDo7Px", defaultMessage: "Slovenia" })],
    ["KP", intl.formatMessage({ id: "ZvV7k0", defaultMessage: "North Korea" })],
    ["KW", intl.formatMessage({ id: "g6e3dg", defaultMessage: "Kuwait" })],
    ["SN", intl.formatMessage({ id: "E902E8", defaultMessage: "Senegal" })],
    ["SM", intl.formatMessage({ id: "YaQUSr", defaultMessage: "San Marino" })],
    ["SL", intl.formatMessage({ id: "mhcNvv", defaultMessage: "Sierra Leone" })],
    ["SC", intl.formatMessage({ id: "NAHlOT", defaultMessage: "Seychelles" })],
    ["KZ", intl.formatMessage({ id: "VMm7cd", defaultMessage: "Kazakhstan" })],
    ["KY", intl.formatMessage({ id: "80nWOt", defaultMessage: "Cayman Islands" })],
    ["SG", intl.formatMessage({ id: "rhaGlx", defaultMessage: "Singapore" })],
    ["SE", intl.formatMessage({ id: "cOtCHW", defaultMessage: "Sweden" })],
    ["SD", intl.formatMessage({ id: "VYWEFA", defaultMessage: "Sudan" })],
    ["DO", intl.formatMessage({ id: "XM2eiF", defaultMessage: "Dominican Republic" })],
    ["DM", intl.formatMessage({ id: "oQCGsZ", defaultMessage: "Dominica" })],
    ["DJ", intl.formatMessage({ id: "iGb1sS", defaultMessage: "Djibouti" })],
    ["DK", intl.formatMessage({ id: "OjT4Gq", defaultMessage: "Denmark" })],
    ["VG", intl.formatMessage({ id: "39y4D4", defaultMessage: "British Virgin Islands" })],
    ["DE", intl.formatMessage({ id: "PGzyr2", defaultMessage: "Germany" })],
    ["YE", intl.formatMessage({ id: "EFE6ZV", defaultMessage: "Yemen" })],
    ["DZ", intl.formatMessage({ id: "xrCy9R", defaultMessage: "Algeria" })],
    ["US", intl.formatMessage({ id: "GZDSC0", defaultMessage: "United States" })],
    ["UY", intl.formatMessage({ id: "EbbVcC", defaultMessage: "Uruguay" })],
    ["YT", intl.formatMessage({ id: "6SzqQV", defaultMessage: "Mayotte" })],
    [
        "UM",
        intl.formatMessage({ id: "DUdaMN", defaultMessage: "United States Minor Outlying Islands" }),
    ],
    ["LB", intl.formatMessage({ id: "tgKpK7", defaultMessage: "Lebanon" })],
    ["LC", intl.formatMessage({ id: "efG8Mm", defaultMessage: "Saint Lucia" })],
    ["LA", intl.formatMessage({ id: "FpzDjr", defaultMessage: "Laos" })],
    ["TV", intl.formatMessage({ id: "5Zsb8t", defaultMessage: "Tuvalu" })],
    ["TW", intl.formatMessage({ id: "K283wu", defaultMessage: "Taiwan" })],
    ["TT", intl.formatMessage({ id: "WS6aEh", defaultMessage: "Trinidad and Tobago" })],
    ["TR", intl.formatMessage({ id: "k/pu+/", defaultMessage: "Turkey" })],
    ["LK", intl.formatMessage({ id: "tm3FzH", defaultMessage: "Sri Lanka" })],
    ["LI", intl.formatMessage({ id: "7HIoTU", defaultMessage: "Liechtenstein" })],
    ["LV", intl.formatMessage({ id: "mNdVd9", defaultMessage: "Latvia" })],
    ["TO", intl.formatMessage({ id: "xqD0n2", defaultMessage: "Tonga" })],
    ["LT", intl.formatMessage({ id: "pFuHho", defaultMessage: "Lithuania" })],
    ["LU", intl.formatMessage({ id: "LhhU6X", defaultMessage: "Luxembourg" })],
    ["LR", intl.formatMessage({ id: "ikBdCN", defaultMessage: "Liberia" })],
    ["LS", intl.formatMessage({ id: "4kjIFD", defaultMessage: "Lesotho" })],
    ["TH", intl.formatMessage({ id: "dQZuWX", defaultMessage: "Thailand" })],
    ["TF", intl.formatMessage({ id: "ZPneo2", defaultMessage: "French Southern Territories" })],
    ["TG", intl.formatMessage({ id: "DIFKwk", defaultMessage: "Togo" })],
    ["TD", intl.formatMessage({ id: "6AXoVq", defaultMessage: "Chad" })],
    ["TC", intl.formatMessage({ id: "FN5U0u", defaultMessage: "Turks and Caicos Islands" })],
    ["LY", intl.formatMessage({ id: "p55qbX", defaultMessage: "Libya" })],
    ["VA", intl.formatMessage({ id: "7/HNiU", defaultMessage: "Vatican" })],
    [
        "VC",
        intl.formatMessage({ id: "nuU4t/", defaultMessage: "Saint Vincent and the Grenadines" }),
    ],
    ["AE", intl.formatMessage({ id: "eMHa+3", defaultMessage: "United Arab Emirates" })],
    ["AD", intl.formatMessage({ id: "WU4UUT", defaultMessage: "Andorra" })],
    ["AG", intl.formatMessage({ id: "YE1l8T", defaultMessage: "Antigua and Barbuda" })],
    ["AF", intl.formatMessage({ id: "uWSAC7", defaultMessage: "Afghanistan" })],
    ["AI", intl.formatMessage({ id: "XRFmnD", defaultMessage: "Anguilla" })],
    ["VI", intl.formatMessage({ id: "VWAeFy", defaultMessage: "U.S. Virgin Islands" })],
    ["IS", intl.formatMessage({ id: "Yr+/el", defaultMessage: "Iceland" })],
    ["IR", intl.formatMessage({ id: "nzwRIp", defaultMessage: "Iran" })],
    ["AM", intl.formatMessage({ id: "5LRsH1", defaultMessage: "Armenia" })],
    ["AL", intl.formatMessage({ id: "90h7/c", defaultMessage: "Albania" })],
    ["AO", intl.formatMessage({ id: "sX2X1Y", defaultMessage: "Angola" })],
    ["AQ", intl.formatMessage({ id: "1vXyK5", defaultMessage: "Antarctica" })],
    ["AS", intl.formatMessage({ id: "1xokhb", defaultMessage: "American Samoa" })],
    ["AR", intl.formatMessage({ id: "wHkOq4", defaultMessage: "Argentina" })],
    ["AU", intl.formatMessage({ id: "D4A2LZ", defaultMessage: "Australia" })],
    ["AT", intl.formatMessage({ id: "ZwXv1C", defaultMessage: "Austria" })],
    ["AW", intl.formatMessage({ id: "Y42Bah", defaultMessage: "Aruba" })],
    ["IN", intl.formatMessage({ id: "i5dhvD", defaultMessage: "India" })],
    ["AX", intl.formatMessage({ id: "1jMkF/", defaultMessage: "Aland Islands" })],
    ["AZ", intl.formatMessage({ id: "NDmBum", defaultMessage: "Azerbaijan" })],
    ["IE", intl.formatMessage({ id: "fGxzwb", defaultMessage: "Ireland" })],
    ["ID", intl.formatMessage({ id: "vQOevT", defaultMessage: "Indonesia" })],
    ["UA", intl.formatMessage({ id: "3T2iOg", defaultMessage: "Ukraine" })],
    ["QA", intl.formatMessage({ id: "331fBb", defaultMessage: "Qatar" })],
    ["MZ", intl.formatMessage({ id: "xrLxhm", defaultMessage: "Mozambiqu" })],
]);
exports.getCountryCodeToNameMap = getCountryCodeToNameMap;
//# sourceMappingURL=country-codes.js.map